// src/layouts/PublicLayout.jsx
import React from "react";

const containerStyle = {
  width: "100vw",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "var(--bg-primary)",
  color: "var(--text-primary)",
  fontFamily: "'Arial', sans-serif",
  boxSizing: "border-box",
  overflowX: "hidden",
  justifyContent: "center",
  alignItems: "center"
};

function PublicLayout({ children }) {
  return (
    <div style={containerStyle}>
      {children}
    </div>
  );
}

export default PublicLayout;
